/* eslint-disable no-plusplus */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';

import hexToRgba from 'hex-to-rgba';
import PropTypes from 'prop-types';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';

import LocaleMessage from '~/components/LocaleMessage';

import { ChartCard, NullData } from './style';

const PIE_SEGMENT_OPACITY = 0.58;

export default function ReportPieChart({
    classes,
    title,
    color,
    segmentColors,
    data,
    dataKey,
    customization = {},
}) {
    // Retornar string (não <text>) para o Recharts usar um único <Text> interno com as
    // coords já calculadas em labelProps. Elemento DOM próprio costuma cair no fallback
    // que ainda desenha o valor (dataKey) — ex.: "0" — por cima do rótulo.
    const CustomPieLabel = d => {
        const raw =
            d.payload && d.payload.name != null ? d.payload.name : d.name;
        if (raw == null || raw === '') return '';
        const s = typeof raw === 'string' ? raw : String(raw);
        return s.length > 10 ? `${s.substring(0, 9)}...` : s;
    };

    const { height, tooltip, innerRadius, outerRadius, stroke } = customization;
    const hasSegmentColors =
        Array.isArray(segmentColors) && segmentColors.length > 0;
    const singleFill = color
        ? `${hexToRgba(color, 0.5)}`
        : 'rgba(136, 132, 216, 0.5)';

    return (
        <ChartCard className={classes}>
            <div>
                <p className="card-title">{title}</p>
            </div>
            {data && data.length > 0 ? (
                <ResponsiveContainer
                    className="card-img-bottom overflow-hidden animated slideInFromLeft animation-duration-1"
                    width="100%"
                    height={height || 200}
                >
                    <PieChart>
                        <Pie
                            data={data}
                            dataKey={dataKey}
                            nameKey="name"
                            stroke={stroke || '#ddd'}
                            innerRadius={innerRadius || 45}
                            outerRadius={outerRadius || 70}
                            fill={
                                hasSegmentColors
                                    ? hexToRgba(
                                          segmentColors[0],
                                          PIE_SEGMENT_OPACITY
                                      )
                                    : singleFill
                            }
                            label={CustomPieLabel}
                            labelLine
                        >
                            {hasSegmentColors
                                ? data.map((entry, index) => (
                                      <Cell
                                          key={`cell-${entry.name}-${index}`}
                                          fill={hexToRgba(
                                              segmentColors[
                                                  index % segmentColors.length
                                              ],
                                              PIE_SEGMENT_OPACITY
                                          )}
                                      />
                                  ))
                                : null}
                        </Pie>
                        <Tooltip content={tooltip} />
                    </PieChart>
                </ResponsiveContainer>
            ) : (
                <NullData>
                    <p>
                        <LocaleMessage msg="label.no_data" />
                    </p>
                </NullData>
            )}
        </ChartCard>
    );
}

ReportPieChart.defaultProps = {
    data: [],
    classes: '',
    title: null,
    color: '',
    segmentColors: null,
    dataKey: 'value',
    customization: {},
};

ReportPieChart.propTypes = {
    data: PropTypes.array,
    classes: PropTypes.string,
    title: PropTypes.element,
    color: PropTypes.string,
    segmentColors: PropTypes.arrayOf(PropTypes.string),
    dataKey: PropTypes.string,
    customization: PropTypes.object,
};
